import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontSizes } from '@/styles'
import TextButton from '@/components/anchor/button'
import PhoneFormatter from '@/components/phone-formatter'

const heightOfLine = '18px'

const StyledAnchor = styled.a`
  font-size: ${fontSizes.small};
  color: ${colors.regular};
  text-decoration: none;
  line-height: ${heightOfLine};
`

const ShowPhoneText = styled(TextButton)`
  font-size: ${fontSizes.small};
  color: ${colors.link};
  padding: 0;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: ${heightOfLine};
`

const ShowPhoneNumber = ({ hidePhone, phoneNum, isRented }) => {
  const [isPhoneNumVisible, setIsPhoneNumVisible] = useState(false)
  const { t } = useTranslation()
  const phoneLink = 'tel:' + phoneNum
  return hidePhone === 0 && phoneNum && !isRented ? (
    <Row>
      {isPhoneNumVisible ? (
        <StyledAnchor href={phoneLink}>
          <PhoneFormatter value={phoneNum} />
        </StyledAnchor>
      ) : (
        <ShowPhoneText
          onClick={() => setIsPhoneNumVisible(true)}
          id="listing-details-show-phone-click"
        >
          {t(
            'listing:b.listing.view.show_phone_number.button',
            'Show phone number'
          )}
        </ShowPhoneText>
      )}
    </Row>
  ) : null
}

export default ShowPhoneNumber
